module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "take-place column ctn-patrimonial-landscape no-edit"
  }, [_c('div', {
    staticClass: "heading-sub-client row"
  }, [_c('router-link', {
    staticClass: "btn-icon",
    attrs: {
      "to": {
        name: 'Client',
        params: {
          clientId: _vm.client.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tLes derniers échanges avec " + _vm._s(_vm.client.firstname) + " " + _vm._s(_vm.client.lastname) + "\n\t\t\t")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('chat', {
    attrs: {
      "title": 'Messages',
      "isAdvisor": true,
      "threads": _vm.threads
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-269e1e02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/Contacts/Chat.vue
// module id = 1089
// module chunks = 0